/*
 * Dependências inernas
 */
import api from 'utils/api';

const getTiposDeLancamento = () => api.get( 'tiposlancamentos' );

export default getTiposDeLancamento;
